import { Loading } from 'module/ui/components/atoms/loading';
import React from 'react';
import styled from 'styled-components';
import { FixedSizeVirtualizedMenuList } from './fixed-size-virtualized-menu-list';
import { VirtualizedMenuList } from './virtualized-menu-list';

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-03);
  border-top: 1px solid var(--divider-subtle);
`;

const MenuListWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export interface ScrollableVirtualizedMenuListProps {
  onLoadMore: () => void;
  hasMore: boolean;
  isLoading: boolean;
  selectProps: Record<string, unknown>;
  /** Use FixedSizeList from react-window for flat option lists (e.g. meetings, emails) */
  useFixedSize?: boolean;
}

export const ScrollableVirtualizedMenuList = ({
  onLoadMore,
  hasMore,
  isLoading,
  selectProps,
  useFixedSize = false,
}: ScrollableVirtualizedMenuListProps) => {
  const loadMoreProps = {
    onLoadMore,
    hasMore,
    isLoading,
  };

  const MenuListComponent = useFixedSize
    ? FixedSizeVirtualizedMenuList
    : VirtualizedMenuList;

  return (
    <MenuListWrapper>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <MenuListComponent {...selectProps} {...loadMoreProps} />
      {isLoading && hasMore && (
        <LoadingContainer>
          <Loading size="small" />
        </LoadingContainer>
      )}
    </MenuListWrapper>
  );
};
